<script>
	export default {

        props: {
            dir: String,
        },

		watch: {
			$mq() {
				console.log(this.$mq);
			}
		},

		mounted() {
			this.$nextTick(() => {
				// setting first icon to active
				$('.gallery-indicator:first').addClass('active');

				// resizing flickity on show to correct the gallery
				$('#product-gallery').on('slide.bs.carousel', (ev) => {
					if ($(ev.relatedTarget).has('.product-images').length) {
						$(ev.relatedTarget).addClass('d-block');
						let gallery = this.$refs['flickity-gallery-' + $(ev.relatedTarget).data('galleryNum')];
						gallery.flickity().resize();
						$(ev.relatedTarget).removeClass('d-block');
					}
				});
			});

			// resizing flickity on show to correct the related tab
			$(document).on('shown.bs.tab', '#related-products-tabs', (ev) => {
				let gallery = this.$refs['flickity-' + $(ev.target).attr('aria-controls')];
				gallery.flickity().resize();
			});
		},

		destroyed() {
			$(document).off('slide.bs.carousel', '#product-gallery');
			$(document).off('shown.bs.tab', '#related-products-tabs');
		},

		methods: {
			// activating carousel manually.
			activateCarousel(num) {
				$('.gallery-indicator').removeClass('active');
				$('#gallery-indicator-' + num).addClass('active');

				$('#product-gallery').carousel(num);
			},

            isLtr() {
			    return this.dir === 'ltr';
            },

			getRelatedGalleryOptions(cellSelector, withArrows = true) {

				return {
					cellSelector: cellSelector, //'.col-sm-6',
					rightToLeft: !this.isLtr(),
					cellAlign: this.isLtr() ? 'left' : 'right',
					groupCells: true,
					contain: true,
					pageDots: false,
					freeScroll: true,
					prevNextButtons: (withArrows) ? this.$mq != 'mobile' : false, //(this.$mq == 'mobile') ? false : true,
					arrowShape: {
						x0: 10,
						x1: 55, y1: 50,
						x2: 60, y2: 50,
						x3: 15
					}
				};
			}
		}

	}
</script>


// WEBPACK FOOTER //
// resources/assets/js/components/ProductPage.vue